import { Net } from '@pacem/pacem-core';
import { ApiParserBase, ApiParameterType } from './types';
//namespace Pacem.Scaffolding.OpenApi {
const ApiMethod = Net.HttpMethod;
export class SwaggerParser extends ApiParserBase {
    _findDefinitionName(definitionHashTag) {
        var pattern = /#\/definitions\/(.+)/;
        var arr = pattern.exec(definitionHashTag);
        if (arr == null || arr.length < 2)
            return definitionHashTag;
        return arr[1];
    }
    parse(content, url) {
        let j = content;
        if (typeof j === 'string') {
            j = JSON.parse(j);
        }
        const json = j;
        let definitions = {};
        for (let def in json.definitions) {
            let name = this._findDefinitionName(def);
            definitions[name] = json.definitions[def];
        }
        let baseUrl = '';
        if (json.host && json.schemes.length > 0) {
            baseUrl = json.schemes[0] + '://' + json.host + json.basePath;
        }
        else if (url) {
            // add scheme, host and basePath just-in-case
            let parsed = /^(https?):\/\/([^\/]+)/.exec(url);
            if (parsed && parsed.length) {
                if (!(json.schemes) && parsed.length > 1) {
                    json.schemes = [parsed[1]];
                }
                if (!json.host && parsed.length > 2) {
                    json.host = parsed[2];
                    json.basePath = '';
                }
                baseUrl = parsed[0];
            }
        }
        else {
            console.warn('Not able to find a base url from the OpenApi specs.');
        }
        let retval = { endpoints: [], definitions: definitions, baseUrl: baseUrl };
        for (let path in json.paths) {
            let src = json.paths[path];
            for (let method of [ApiMethod.Get, ApiMethod.Delete, ApiMethod.Post, ApiMethod.Put]) {
                let op = src[method.toLowerCase()];
                if (op) {
                    let endpoint = this._tryGetEndpoint(json, op, path, method);
                    retval.endpoints.push(endpoint);
                }
            }
        }
        return retval;
    }
    _tryGetEndpoint(json, op, path, method) {
        return {
            response: this._tryGetResponse(json, op),
            path: path,
            method: method,
            parameters: this._tryGetParameters(json, op)
        };
    }
    _translateType(type, format) {
        switch (type) {
            case 'number':
            case 'integer':
                return ApiParameterType.Number;
            case 'boolean':
                return ApiParameterType.Boolean;
            case 'string':
                switch (format) {
                    case 'date':
                    case 'date-time':
                        return ApiParameterType.Datetime;
                    case 'byte':
                        return ApiParameterType.Binary;
                    case 'binary':
                        throw `Binary octets not supported.`;
                }
                return ApiParameterType.String;
        }
        return ApiParameterType.String;
    }
    _tryGetParameters(json, operation) {
        return (operation.parameters || []).map(p => {
            const pb = p;
            let retval = {
                name: pb.name,
                required: pb.required || false
            };
            let type = p.type;
            if (p.schema) {
                let pbody = p;
                retval.type = ApiParameterType.Object;
                let name = retval.fullType = this._findDefinitionName(pbody.schema.$ref);
                retval.meta = json.definitions[name];
            }
            else if (type) {
                retval.type = this._translateType(type, p.format);
            }
            return retval;
        });
    }
    _tryGetResponse(json, operation) {
        let ok = operation.responses['200'];
        if (!ok || !ok.schema)
            return null;
        let type = ok.schema.type || 'object', meta, name;
        if (ok.schema.$ref) {
            name = this._findDefinitionName(ok.schema.$ref);
            meta = json.definitions[name];
        }
        else {
            meta = ok.schema;
            if (ok.schema.items) {
                if (ok.schema.items.hasOwnProperty('$ref')) {
                    name = this._findDefinitionName(ok.schema.items.$ref);
                    meta = json.definitions[name];
                }
                else {
                    meta = ok.schema.items;
                }
            }
        }
        return { type: type, fullType: name, meta: meta };
    }
}
